module.exports = __webpack_public_path__ + "img/airPurifiers_0_0.b323f536.png";